import { useMutation  } from '@tanstack/react-query';
import { ApiService } from '../API/AxiosInstance';

// const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData'))?.sub_id : ''
export const useInitiateIdleCash = () => {
  return useMutation({
    mutationFn: async (userId) => {
      const res = await ApiService().post(
        `${process.env.REACT_APP_BASE_URL}users/${userId}/idle-cash/initialise`
      );
      return res?.data?.message;
    },
    retry: 0
  });
};